var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"container center-vertically"},[_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v(" 粤ICP备2023134218号 ")])])])])
}]

export { render, staticRenderFns }